module.exports = __webpack_public_path__ + "static/media/react-brands.d8cf7740.svg";